import { createSlice } from '@reduxjs/toolkit';
import { OnboardingStepTypes } from 'src/types/enum';
type onboardingType = {
  isOnboarding: boolean;
  stepCount?: number;
  stepsContext?: string;
  updateOnboardingStep: boolean;
};
const initialState: onboardingType = {
  isOnboarding: false,
  stepCount: 0,
  stepsContext: OnboardingStepTypes.CHAT,
  updateOnboardingStep: false
};

const onboardingSlice = createSlice({
  name: 'context',
  initialState,
  reducers: {
    toggleOnboarding: (state) => {
      state.isOnboarding = !state.isOnboarding;
    },
    updateOnboarding: (state, { payload }) => {
      state.isOnboarding = payload?.isOnboarding;
      state.stepCount = payload?.stepCount || 0;
      state.stepsContext = payload?.stepsContext || OnboardingStepTypes.CHAT;
      state.updateOnboardingStep = payload?.updateOnboardingStep;
    }
  }
});

export const { toggleOnboarding, updateOnboarding } = onboardingSlice.actions;

export const reducer = onboardingSlice.reducer;
